export default __webpack_public_path__ + "static/media/pause.5bbc5e97.png";